<template>
  <b-container>
    <h1 class="text-center pt-4 pb-4">{{ $t("title.TaskDispatcher") }}</h1>

      <b-row class="mt-4">
        <b-col sm="4">
          <b-form-group v-slot="{ ariaDescribedby }">
            <b-form-radio v-model="taskRadio" :aria-describedby="ariaDescribedby" name="taskEventList"
              value="taskEventList">{{ $t("title.taskTable") }}</b-form-radio>
            <b-form-radio v-model="taskRadio" :aria-describedby="ariaDescribedby" name="taskByBuilding"
              value="taskByBuilding">{{ $t("label.taskByBuilding") }}</b-form-radio>
          </b-form-group>
        </b-col>
      </b-row>

      <div v-if="taskRadio === 'taskByBuilding'">
        <TaskByBuilding />
      </div>
      <div v-if="taskRadio === 'taskEventList'">
        <TaskTable v-on:changePage="setNextPage" />
      </div>
    
  </b-container>
</template>

<script>
import moment from "moment";
import axios from "axios";
import { globalF } from "../../Helpers";
//import TaskEventList from "./TaskEventList.vue";
import TaskByBuilding from "./TaskByBuilding.vue";
import TaskTable from "./TaskTable.vue";

export default {
  mixins: [globalF],
  props: [],
  data() {
    return {
      taskEvent: [],
      taskRadio: "taskEventList",
      success: false,
      error: "",
      spinner: false,
      task: null,
      taskList: [],
      taskListTable: [],
      rawData: [],
      teamsGroup: [],
      teamBuildings: [],
      buildings: [],
      building: null,
      sortBy: "displayName",
      sortDesc: false,
      perPage: 10,
      currentPage: 1,
      search: "",
      options: [
        { value: 10, text: "10" },
        { value: 25, text: "25" },
        { value: 50, text: "50" },
        { value: 100, text: "100" },
      ],
      teamSelect: null,
      existingTeamForBuilding: false,
      newGroupName: "",
      teamPlan: null,
      teamBucket: null,
    };
  },
  validations() { },
  mounted() {
    //this.getTeamBuildingTaskList();
  },
  watch: {},
  computed: {
    user: function () {
      return this.$store.getters.getUser;
    },
    url: function () {
      return this.getUrl();
    },
    rows() {
      return this.items.length;
    },
    items: function () {
      let mydatalist = this.taskListTable;
      let search = this.search.toLowerCase();
      return mydatalist.filter(
        (p) =>
          p.buildingName.toString().toLowerCase().includes(search) ||
          p.teamName.toString().toLowerCase().includes(search) ||
          p.createdDateTime.toLowerCase().includes(search) ||
          p.dueDateTime.toLowerCase().includes(search) ||
          p.completedDateTime.toLowerCase().includes(search)
      );
    },
    myfields: function () {
      return [
        {
          key: "buildingName",
          sortable: true,
          label: this.$t("label.buildingName"),
        },
        { key: "teamName", sortable: true, label: this.$t("label.teamName") },
        {
          key: "createdDateTime",
          sortable: true,
          label: this.$t("label.createdDateTime"),
          formatter: (value) => {
            return value ? moment(value).format("YYYY-MM-DD HH:mm:ss") : "";
          },
        },
        {
          key: "dueDateTime",
          sortable: true,
          label: this.$t("label.dueDateTime"),
          formatter: (value) => {
            return value ? moment(value).format("YYYY-MM-DD HH:mm:ss") : "";
          },
        },
        {
          key: "completedDateTime",
          sortable: true,
          label: this.$t("label.completedDateTime"),
          formatter: (value) => {
            return value ? moment(value).format("YYYY-MM-DD HH:mm:ss") : "";
          },
        },
      ];
    },
  },
  methods: {
    getTeamBuildingTaskList() {
      this.spinner = true;
      let urls = this.$store.getters.getUrlsList;
      let url = urls[process.env.VUE_APP_WHERE].json;
      let destination = this.getDestinationByUserRole(this.user.role);

      let promise = this.validateToken();
      promise.then(() => {
        axios
          .post(
            url,
            { request: "getTeamBuildingTaskList", destination: destination },
            { headers: { "Content-Type": "application/json" } }
          )
          .then((response) => {
            this.spinner = false;
            this.teamBuildings = response.data.teamBuildings;
            this.buildings = response.data.buildings;
            this.setTasksList(response.data.taskEvent);
          })
          .catch(() => {
            this.spinner = false;
            this.error = this.$t("info.errorgeneric");
          });
      });
    },
    setTasksList: function (tasks) {
      this.taskList = tasks.map((t) => {
        let text = t.Title + " (" + t.Creation + ") ";
        return {
          text: text,
          value: t,
        };
      });

      this.taskList.unshift({
        text: this.$t("label.selectTask"),
        value: null,
      });
    },
    resetTable: function () {
      this.search = "";
    },
    OnTaskClick: function () {
      this.spinner = true;
      this.getTaskBuilding();
    },
    getTaskBuilding: function () {
      let obj = {
        request: "getTaskBuilding",
        idTask: this.task.Id,
        destination: this.getDestinationByUserRole(this.user.role)
      };
      axios
        .post(this.url, obj, {
          headers: { "Content-Type": "application/json" },
        })
        .then((response) => {
          this.setPlannerTasksList(response.data);
        })
        .catch(() => {
          this.spinner = false;
          this.error = this.$t("info.errorgeneric");
        });
    },
    setPlannerTasksList(taskBuilding) {
      let token = this.getGlobalData("accessToken");

      let request = [];

      for (let i = 0; i < taskBuilding.length; i++) {
        let IdTaskGraph = taskBuilding[i].IdTaskGraph;

        //let graphEndPoint = `https://graph.microsoft.com/v1.0/planner/tasks/${IdTaskGraph}`;
        let graphEndPoint = `https://graph.microsoft.com/beta/planner/tasks/${IdTaskGraph}`;

        request.push(this.getPlannerTasks(token, graphEndPoint));
      }

      Promise.allSettled(request).then((results) => {
        let successList = results.filter((r) => r.status === "fulfilled");
        if (successList.length > 0) {
          this.setTaskBuilding(successList);
        }

        let errorList = results.filter((r) => r.status === "rejected");
        if (errorList.length > 0) {
          this.logError(errorList);
        }
      });
    },
    getPlannerTasks(token, graphEndpoint) {
      return axios.get(graphEndpoint, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
    },
    setTaskBuilding(successList) {
      this.spinner = false;
      let buildings = this.buildings;
      let teamBuildings = this.teamBuildings;

      let taskList = successList.map((s) => {
        let taskList = s.value.data;
        taskList.teamName = "";
        taskList.buildingName = "";
        let teamBuilding = teamBuildings.find(
          (t) => t.TeamPlan === taskList.planId
        );
        if (teamBuilding) {
          let building = buildings.find(
            (b) => b.Id === teamBuilding.IdBuilding
          );
          taskList.teamName = teamBuilding.TeamName;
          if (building) {
            taskList.buildingName = building.NOMDIV;
          }
        }
        return taskList;
      });

      this.taskListTable = taskList;
    },
    logError(errorList) {
      let obj = {
        request: "logError",
        jobName: "TaskDispatcher",
        errorList: errorList,
      };
      axios
        .post(this.url, obj, {
          headers: { "Content-Type": "application/json" },
        })
        .then(() => {
          this.spinner = false;
        })
        .catch(() => {
          this.spinner = false;
          this.error = this.$t("info.errorgeneric");
        });
    },
    setNextPage(page) {
      this.$emit("changePage", page);
    },
  },
  components: {
    //TaskEventList,
    TaskTable,
    TaskByBuilding
  },
};
</script>
